import { useEffect, useState } from 'react';
import { Chip } from '@mui/joy';
import { getPotentielsParrainagesModifieById } from '@app/api/data/potentiels-parrainages-modifie';

interface ModificationBadgeProps {
    potentielId: number;
}

const ModificationBadge = ({ potentielId }: ModificationBadgeProps) => {
    const [hasModifications, setHasModifications] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkModifications = async () => {
            try {
                await getPotentielsParrainagesModifieById(potentielId.toString());
                setHasModifications(true);
            } catch (error) {
                setHasModifications(false);
            } finally {
                setLoading(false);
            }
        };
        checkModifications();
    }, [potentielId]);

    if (loading) return null;

    if (hasModifications) {
        return (
            <Chip size="sm" color="warning" variant="soft">
                Modifications en attente
            </Chip>
        );
    }

    return null;
};

export default ModificationBadge; 